<template>
  <div class="d-flex align-center">
    <div>
      <div class="d-flex align-center">
        <span class="font-17 text-systock-blue">Comparação Entre Datas</span>
        <v-icon :size="30" class="mx-2" color="#0a3950">mdi-arrow-right-bold</v-icon>
      </div>

      <div class="mt-n3 pt-1px mb-n2 font-11">Clique com botão direito nas datas abaixo</div>
    </div>

    <table id="tabela-comparacao-datas" class="text-center" :class="{'animacao': exibir_animacao}">
      <tr>
        <th>{{ datas_comparacao.data_inicial }}</th>
        <th>{{ datas_comparacao.data_final }}</th>
        <th>Dif.</th>
        <th>%</th>
      </tr>

      <tr>
        <td>R$ {{ Helpers.formatarValorComCasas(VALOR_INICIAL, 0)}}</td>
        <td>R$ {{ Helpers.formatarValorComCasas(VALOR_FINAL, 0) }}</td>
        <td>R$ {{ Helpers.formatarValorComCasas(Math.abs(VALOR_INICIAL - VALOR_FINAL), 0) }}</td>
        <td>{{ Helpers.formatarValorComCasas(DIFERENCA_PERCENTUAL, 2) }}%</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "ComparacaoEntreDatas",
  props: {
    datas_comparacao: Object,
    dados_linha: Object,
  },
  data: () => ({
    exibir_animacao: false,
  }),
  computed: {
    VALOR_INICIAL() {
      if (!this.dados_linha || this.dados_linha.length === 0) return 0;
      return Number(this.dados_linha[this.datas_comparacao.data_inicial] || 0);
    },
    VALOR_FINAL() {
      if (!this.dados_linha || this.dados_linha.length === 0) return 0;
      return Number(this.dados_linha[this.datas_comparacao.data_final] || 0);
    },
    DIFERENCA_PERCENTUAL() {
      if (!this.VALOR_INICIAL || this.VALOR_INICIAL === 0) return 0;
      const dif = Math.abs(this.VALOR_INICIAL - this.VALOR_FINAL)
      return (dif / this.VALOR_INICIAL) * 100;
    }
  },
  watch: {
    DIFERENCA_PERCENTUAL() {
      this.animar();
    }
  },
  methods: {
    animar() {
      this.exibir_animacao = true;
      setTimeout(() => this.exibir_animacao = false, 1000);
    }
  }
}
</script>

<style scoped>
#tabela-comparacao-datas {
  border-collapse: collapse;
  font-size: 0.84rem;
}
#tabela-comparacao-datas tr th, tr td {
  padding: 2px 0;
  border: 1px solid rgba(0,0,0,.3);
}
#tabela-comparacao-datas tr th {
  background: #f7f8ff;
  width: 90px !important;
}
#tabela-comparacao-datas tr td {
  color: #282828;
}
.animacao td, .animacao th {
  animation: animacao-tabela .3s linear;
}
@keyframes animacao-tabela {
  0% {
    font-size: 0.84rem;
  }
  50% {
    font-size: 0.1rem;
  }
  100% {
    font-size: 0.84rem;
  }
}
</style>
